import LoadingButton from '@mui/lab/LoadingButton';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import TextField from 'components/ReduxForm/TextField';
import Select from 'components/ReduxForm/Select';
import ReactSelect from 'components/ReduxForm/ReactSelect';
import PropTypes from 'prop-types';
import { Field, Form, FormSpy } from 'react-final-form';
import { useDispatch, useSelector } from 'react-redux';
import { create } from 'redux/modules/contactForms';
import { useMemo, useState } from 'react';
import { Grid, LinearProgress, Paper } from '@mui/material';
import { green } from '@mui/material/colors';
import validation from './valdiateContactForm';
import { useTranslation } from '../../hooks/useTranslation';

const useStyles = makeStyles(
  (theme) => ({
    paper: {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      padding: theme.spacing(2),
      overflow: 'hidden',
    },
    progress: {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      width: `calc(100% + calc(${theme.spacing(2).replace('px', '')} * 2))`,
      position: 'relative',
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      left: `-${theme.spacing(2)}`,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      top: `-${theme.spacing(2)}`,
    },
    progressFinal: {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      width: `calc(100% + calc(${theme.spacing(2).replace('px', '')} * 2))`,
      position: 'relative',
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      left: `-${theme.spacing(2)}`,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      bottom: `-${theme.spacing(2)}`,
    },
    buttons: {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      marginTop: theme.spacing(2),
    },
    wrapper: {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      margin: theme.spacing(1),
      position: 'relative',
    },
    buttonSuccess: {
      backgroundColor: green[500],
      '&:hover': {
        backgroundColor: green[700],
      },
    },
    buttonProgress: {
      color: green[500],
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12,
    },
    paperTable: {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      marginBottom: theme.spacing(4),
    },
    datePicker: {
      fontSize: 16,
    },
  }),
  { name: 'BringerContactForm' }
);
const ContactForm = ({
  onChange = () => undefined,
  onError = () => undefined,
  onSuccess = () => undefined,
  // onCancel = () => {},
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const onSubmit = async (values: any) => {
    values.formId = 'generalForm';
    values.countryId = values.country && values.country.value;
    console.log(values, 'values');
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'then' does not exist on type '{ key: any... Remove this comment to see the full error message
    await dispatch(create('submitForm', values)).then(onSuccess).catch(onError);
  };

  const success = false;
  const buttonClassname = clsx({
    [classes.buttonSuccess]: success,
  });

  const [valuesState] = useState({});
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'countries' does not exist on type 'Defau... Remove this comment to see the full error message
  const countries = useSelector((state) => state.countries.result.allCountries);

  const { countrySelectOptions } = useMemo(() => {
    const result = countries.reduce(
      (acc: any, curr: any) => {
        acc.countriesById[curr.id] = curr.name;
        acc.countrySelectOptions.push({
          label: curr.name,
          value: curr.id,
        });
        return acc;
      },
      { countriesById: {}, countrySelectOptions: [] }
    );
    return result;
  }, []);

  return (
    <Form initialValues={valuesState} onSubmit={onSubmit} validate={validation}>
      {({ handleSubmit, submitting, pristine }) => (
        <form onSubmit={handleSubmit} noValidate>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Paper className={classes.paper}>
                {submitting && (
                  <LinearProgress variant="indeterminate" className={classes.progress} />
                )}
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Field
                      fullWidth
                      required
                      variant="outlined"
                      name="companyName"
                      component={TextField}
                      label={t('public.contact.form.company')}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Field
                      fullWidth
                      required
                      variant="outlined"
                      name="companyWebsite"
                      component={TextField}
                      label={t('public.contact.form.company.website')}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Field
                      fullWidth
                      required
                      variant="outlined"
                      name="fullName"
                      // @ts-expect-error ts-migrate(2322) FIXME: Type '({ input: { name, onChange, value, ...restIn... Remove this comment to see the full error message
                      component={TextField}
                      label={t('public.contact.form.full.name')}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Field
                      fullWidth
                      required
                      variant="outlined"
                      name="email"
                      // @ts-expect-error ts-migrate(2322) FIXME: Type '({ input: { name, onChange, value, ...restIn... Remove this comment to see the full error message
                      component={TextField}
                      label={t('public.contact.form.email')}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Field
                      fullWidth
                      required
                      variant="outlined"
                      name="phone"
                      // @ts-expect-error ts-migrate(2322) FIXME: Type '({ input: { name, onChange, value, ...restIn... Remove this comment to see the full error message
                      component={TextField}
                      label={t('public.contact.form.phone')}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Field
                      fullWidth
                      required
                      variant="outlined"
                      name="fullAddress"
                      // @ts-expect-error ts-migrate(2322) FIXME: Type '({ input: { name, onChange, value, ...restIn... Remove this comment to see the full error message
                      component={TextField}
                      label={t('public.contact.form.address')}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Field
                      key="country"
                      fullWidth
                      required
                      variant="outlined"
                      name="country"
                      classes={{
                        // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectFieldPlaceholder' does not exist o... Remove this comment to see the full error message
                        placeholder: classes.selectFieldPlaceholder,
                      }}
                      inputInput={{
                        classes: {
                          // @ts-expect-error ts-migrate(2339) FIXME: Property 'textField' does not exist on type 'Class... Remove this comment to see the full error message
                          root: `${classes.textField} ${classes.selectField}`,
                          // @ts-expect-error ts-migrate(2339) FIXME: Property 'textFieldInput' does not exist on type '... Remove this comment to see the full error message
                          input: classes.textFieldInput,
                          // @ts-expect-error ts-migrate(2339) FIXME: Property 'textFieldInputUnderline' does not exist ... Remove this comment to see the full error message
                          underline: classes.textFieldInputUnderline,
                        },
                      }}
                      cacheOptions
                      defaultOptions
                      styles={{
                        menu: (base: any) => ({
                          ...base,
                          zIndex: 9,
                        }),
                        indicatorSeparator: (base: any) => ({
                          ...base,
                          backgroundColor: 'transparent',
                        }),
                        dropdownIndicator: (base: any) => ({
                          ...base,
                          padding: 0,
                        }),
                      }}
                      component={ReactSelect}
                      // @ts-expect-error ts-migrate(2339) FIXME: Property 'browser' does not exist on type 'Process... Remove this comment to see the full error message
                      menuPortalTarget={process.browser && document.body}
                      options={countrySelectOptions || []}
                      label={t('public.contact.form.country')}
                      placeholder={t('public.contact.form.country')}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Field
                      fullWidth
                      required
                      variant="outlined"
                      name="taxId"
                      // @ts-expect-error ts-migrate(2322) FIXME: Type '({ input: { name, onChange, value, ...restIn... Remove this comment to see the full error message
                      component={TextField}
                      label={t('public.contact.form.tax.id')}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Field
                      fullWidth
                      required
                      variant="outlined"
                      name="serviceInterested"
                      component={Select}
                      options={[
                        {
                          label: 'Air & ocean freight',
                          value: 'Air & ocean freight',
                        },
                        {
                          label: 'Cross-border international shipping',
                          value: 'Cross-border international shipping',
                        },
                        {
                          label: 'E-commerce international shipping',
                          value: 'E-commerce international shipping',
                        },
                        {
                          label: 'Fulfillment services',
                          value: 'Fulfillment services',
                        },
                        {
                          label: 'Logistics consulting services',
                          value: 'Logistics consulting services',
                        },
                        {
                          label: 'Something else',
                          value: 'Something else',
                        },
                      ]}
                      label={t('public.contact.form.service')}
                    />
                  </Grid>
                </Grid>
                {submitting && (
                  <LinearProgress variant="indeterminate" className={classes.progressFinal} />
                )}
              </Paper>
              <div className={classes.buttons}>
                <Grid container justifyContent="space-between">
                  <Grid item />
                  <Grid item>
                    <LoadingButton
                      type="submit"
                      variant="contained"
                      color="primary"
                      className={buttonClassname}
                      loading={submitting}
                      disabled={submitting || pristine}
                    >
                      {t('public.contact.form.btn.submit')}
                    </LoadingButton>
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
          <FormSpy
            // subscription={{ dirty: true }}
            onChange={({ values }) => {
              // @ts-expect-error ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
              onChange(values);
            }}
          />
        </form>
      )}
    </Form>
  );
};

ContactForm.propTypes = {
  onError: PropTypes.func,
  onSuccess: PropTypes.func,
  onChange: PropTypes.func,
};

export default ContactForm;
